import React from 'react';
import './YearChanger.css';

const YearChanger = () => {
    return (
        <div className="year-changer__body">
            <div className="text div-0">
                <span className="span-0">2</span>
                <span className="span-1">3</span>
                <span className="span-2">4</span>
                <span className="span-3">5</span>
            </div>
            <div className="text div-1">
                <span className="span-0">0</span>
                <span className="span-1">1</span>
                <span className="span-2">2</span>
                <span className="span-3">3</span>
            </div>
            <div className="text div-2">
                <span className="span-0">2</span>
                <span className="span-1">3</span>
                <span className="span-2">4</span>
                <span className="span-3">5</span>
            </div>
            <div className="text div-3">
                <span className="span-0">1</span>
                <span className="span-1">2</span>
                <span className="span-2">3</span>
                <span className="span-3">4</span>
            </div>
        </div>
    )
}

export default YearChanger
